import { useState } from 'react';
import { Icon } from '@iconify/react';
import { VISITOR_TYPE_AVATAR, VISITOR_TYPE_ICON, initials } from '../visitorConstants';

// photo_url points at a file uploaded elsewhere, so it can 404 long after the
// visitor row was written. Falling back to initials keeps the row aligned
// instead of collapsing to a broken-image glyph.
const VisitorAvatar = ({ visitor, size = 36, className = '' }) => {
    const [broken, setBroken] = useState(false);
    const tint = VISITOR_TYPE_AVATAR[visitor?.visitor_type] || VISITOR_TYPE_AVATAR.OTHER;
    const showPhoto = !!visitor?.photo_url && !broken;

    return (
        <div
            className={`tw-relative tw-shrink-0 tw-rounded-full tw-overflow-hidden tw-flex tw-items-center tw-justify-center tw-font-bold ${tint} ${className}`}
            style={{ width: size, height: size, fontSize: Math.max(size * 0.34, 10) }}
        >
            {showPhoto ? (
                <img
                    src={visitor.photo_url}
                    alt={visitor.name || 'Visitor'}
                    onError={() => setBroken(true)}
                    className="tw-w-full tw-h-full tw-object-cover"
                />
            ) : visitor?.name ? (
                <span>{initials(visitor.name)}</span>
            ) : (
                <Icon icon={VISITOR_TYPE_ICON[visitor?.visitor_type] || VISITOR_TYPE_ICON.OTHER} />
            )}
        </div>
    );
};

export default VisitorAvatar;
